import { COLORS } from '../services/constants/colors';

/* eslint-disable no-nested-ternary */
export const stringToColor = (string: string) => {
	let hash = 0;
	let i;
	/* eslint-disable no-bitwise */
	for (i = 0; i < string.length; i += 1) {
		hash = string.charCodeAt(i) + ((hash << 5) - hash);
	}
	let color = '#';
	for (i = 0; i < 3; i += 1) {
		const value = (hash >> (i * 8)) & 0xff;
		color += `00${value.toString(16)}`.slice(-2);
	}
	/* eslint-enable no-bitwise */
	return `${color}70`;
};

export const stringAvatar = (name: string, size?: string) => {
	const newSize = size || 'md';

	if (!name) return {};
	const children = name.includes(' ')
		? `${name?.split(' ')?.[0]?.[0]}${name?.split(' ')?.[1]?.[0]}`
		: name?.[0];
	return {
		sx: {
			bgcolor: stringToColor(name),
			color: COLORS.font_status,
			fontWeight: 'bold',
			width:
				newSize === 'xxs'
					? '1.25rem'
					: newSize === 'xs'
						? '1.35rem'
						: newSize === 'sm'
							? '1.8rem'
							: newSize === 'md'
								? 40
								: 80,
			height:
				newSize === 'xxs'
					? '1.25rem'
					: newSize === 'xs'
						? '1.35rem'
						: newSize === 'sm'
							? '1.8rem'
							: newSize === 'md'
								? 40
								: 80,
			fontSize:
				newSize === 'xxs'
					? '0.8rem'
					: newSize === 'xs'
						? '1rem'
						: newSize === 'sm'
							? '1.25rem'
							: newSize === 'md'
								? 30
								: 65,
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			p: 0,
		},
		children,
	};
};
